import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {Actions, ofType} from '@ngrx/effects';
import * as cyberSourceActions from '@app/payment/services/store/actions/cyber-source.action';
import {CyberSourceActionTypes, DeviceDataCollection} from '@app/payment/services/store/actions/cyber-source.action';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CyberSourceDeviceDataCollectionFormComponent} from '@app/payment/components/cybersource/cyber-source-device-data-collection-form/cyber-source-device-data-collection-form.component';
import {ConsumerAuthenticationInformationSetup} from '@app/model/cyber-source/payer-auth-setup-response';
import {isPlatformBrowser} from '@angular/common';
import {Store} from '@ngrx/store';
import {LaunchDialogService} from '@spartacus/storefront';

@UntilDestroy()
@Component({
  selector: 'dcp-cyber-source-place-order',
  templateUrl: './cyber-source-place-order.component.html',
  styleUrl: './cyber-source-place-order.component.scss'
})
export class CyberSourcePlaceOrderComponent implements OnInit, OnDestroy {

  @ViewChild(CyberSourceDeviceDataCollectionFormComponent) deviceDataCollectionForm?: CyberSourceDeviceDataCollectionFormComponent;
  deviceDataCollectionSetup: ConsumerAuthenticationInformationSetup;
  deviceDataCollectionHandler: any;
  threeDsResponseHandler: any;

  constructor(@Inject(PLATFORM_ID) private platformId: string,
              private actions$: Actions,
              private store: Store,
              private cdr: ChangeDetectorRef,
              private launchDialogService: LaunchDialogService,
  ) {
  }

  ngOnInit(): void {
    this.listenToDeviceDataCollectionAction();
    this.listenToDeviceDataCollectionResult();
    this.listenToThreeDsResult();
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('message', this.deviceDataCollectionHandler);
      window.removeEventListener('message', this.threeDsResponseHandler);
    }
  }

  private listenToDeviceDataCollectionAction() {
    this.actions$.pipe(
      ofType(CyberSourceActionTypes.DeviceDataCollection),
      untilDestroyed(this),
    ).subscribe((action: DeviceDataCollection) => {
      this.deviceDataCollectionSetup = action.authEnrollmentData;
      this.cdr.detectChanges();
      this.deviceDataCollectionForm.submit();
    });
  }

  private listenToDeviceDataCollectionResult() {
    if (isPlatformBrowser(this.platformId)) {
      this.deviceDataCollectionHandler = async (event) => {
        if (!!this.deviceDataCollectionSetup && this.deviceDataCollectionSetup.deviceDataCollectionUrl?.includes(event.origin)) {
          this.store.dispatch(new cyberSourceActions.DeviceDataCollectionFinished(this.deviceDataCollectionSetup.referenceId));
        }
      };
      window.addEventListener('message', this.deviceDataCollectionHandler);
    }
  }

  private listenToThreeDsResult() {
    if (isPlatformBrowser(this.platformId)) {

      this.threeDsResponseHandler = (event) => {
        if (event.data?.type === '3DSComplete') {

          if (event.data.cancelled) {
            this.store.dispatch(new cyberSourceActions.PaymentFailure());
          } else {
            this.store.dispatch(new cyberSourceActions.Validate3ds(event.data.transactionId));
          }

          this.launchDialogService.closeDialog('3DS complete');
        }
      };
      window.addEventListener('message', this.threeDsResponseHandler);
    }
  }
}
